import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';

@Injectable({ providedIn: 'root' })
export class ApiRpfi15Service {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);
  private readonly http = inject(HttpClient);

  private get token(): string {
    return this.cookieService.get('token');
  }

  getRpfi15ForTable(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<unknown> {
    return this.apiMethodService.request('/FinanceReports/getRpfi15ForTable', 'GET', this.baseUrl, {
      isConsoleLog: true,
      labelLog: 'getRpfi15ForTable',
      token: this.token,
      headerOnly: false,
      params: {
        siteId: params.siteId,
        startDate: params.startDate,
        endDate: params.endDate,
      },
    });
  }

  getRpfi15Pdf(params: {
    siteId: number;
    startDate: string;
    endDate: string;
  }): Observable<Uint8Array> {
    const httpParams = new HttpParams()
      .set('siteId', params.siteId)
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);

    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
      Accept: 'application/octet-stream, application/pdf, */*',
    });

    return this.http
      .get(`${this.baseUrl}/Reports/rpfi15/pdf`, {
        headers,
        params: httpParams,
        responseType: 'arraybuffer',
      })
      .pipe(map((buffer) => new Uint8Array(buffer)));
  }
}
